
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import LazyImg from '@/components/lazyImg/index.vue'

@Observer
@Component({
  components: { LazyImg }
})
export default class AboutListItem extends Vue {
  @Prop({ required: true }) data

  get AboutStore() {
    return this.$store.$storeAbout
  }
  onAboutViewAdd(item) {
    this.AboutStore.onAboutViewAdd(item.id)
  }
  mounted() {}
  updated() {}
  destroyed() {}
}
